import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DebtExpectBackend, Order, Sort, TYPE_SEARCH } from 'shared';
import { PaginateQuery, PaginatorModel } from 'symbols';
import { DebtFilterModel, DebtModel } from '../symbols';

@Injectable()
export class DebtService {
  public sortDefault$ = new BehaviorSubject({ sort: Sort.CREATED, debt: Order.DESC });

  private readonly apiUrl = '/api/debts';


  constructor(private http: HttpClient) {
  }

  getDebtList(filter?: PaginateQuery<DebtFilterModel>): Observable<PaginatorModel<DebtModel> & {
    debtsAmount: number
  }> {
    const params: { [key: string]: any } = {
      page: filter?.page || 1,
      limit: filter?.limit || 50,
      sortBy: `${filter?.sortBy[0][0]}:${filter?.sortBy[0][1]}`,
      typeSearch: filter?.filter?.typeSearch || TYPE_SEARCH.BY_METADATA
    };


    if (filter?.filter?.typeSearch === TYPE_SEARCH.BY_NUMBER) {
      params['filter.docNumber'] = filter?.filter?.searchText || '';
    } else {
      params['search'] = filter?.filter?.searchText || '';
    }
    if (filter?.filter?.specialAttention) {
      params['filter.specialAttention'] = filter?.filter?.specialAttention;
    }
    if (filter?.filter?.onlyWithDebt) {
      params['filter.onlyWithDebt'] = filter?.filter?.onlyWithDebt;
    }

    if (filter?.filter?.finalMaturityDate) {
      params['filter.finalMaturityDate'] = filter?.filter?.finalMaturityDate;
    }

    return this.http.get<PaginatorModel<DebtModel> & { debtsAmount: number }>(this.apiUrl, { params });
  }


  getDebtListLazy(url: string): Observable<PaginatorModel<DebtModel> & { debtsAmount: number }> {
    return this.http.get<PaginatorModel<DebtModel> & { debtsAmount: number }>(url);
  }

  getDebtById(id: string): Observable<DebtModel> {
    return this.http.get<DebtModel>(`${this.apiUrl}/debt/${id}`);
  }

  updateDebt(id: string, debt: DebtExpectBackend, force: boolean): Observable<DebtModel> {
    return this.http.patch<DebtModel>(`${this.apiUrl}/${id}`, { ...debt, force });
  }

}
